module.exports = __webpack_public_path__ + "img/avatar.06308040.png";